import _debounce from "https://cdn.jsdelivr.net/npm/lodash.debounce@4.0.8/+esm"

let initialLogoHeight;
let slimLogoHeight;
let initialHeaderHeight = 0; // as set in CSS
let headerMinHeight = 0; // as set in CSS
let headerEl;
let logoEl;
let productReviewsHeaderClickHandler = null;
const slimHeader = () => {
  // console.log("slim")
  headerEl?.style.setProperty("--slim-height", `${slimLogoHeight}px`);
  headerEl?.classList.add("slim");
  logoEl?.querySelector("img.desktop-logo-image").style.setProperty("--slim-logo-height", `${slimLogoHeight}px`);
}

const fatHeader = () => {
  // console.log("fat")
  headerEl.classList.remove("slim")
}

const scrollHandler = () => {
  if (window.scrollY + (headerEl.classList.contains("slim") ? initialHeaderHeight : 0) > initialHeaderHeight) {
    if (!headerEl.classList.contains("slim")) slimHeader();
  } else if (headerEl.classList.contains("slim")) {
    fatHeader();
  }
}


const init = () => {
  if (!_debounce) return;

  headerEl = document.querySelector(".site-header-main");
  logoEl = headerEl.querySelector(".site-logo")

  initialHeaderHeight = headerEl.getBoundingClientRect().height;
  headerMinHeight = +headerEl.style.minHeight.replace("px", "")

  initialLogoHeight = +logoEl.querySelector("img.desktop-logo-image").style.height.replace("px", "")
  slimLogoHeight = +logoEl?.dataset.slimHeight?.replace("px", "");

  window.addEventListener("scroll", _debounce(scrollHandler, 250, {
    trailing: true, maxWait: 500
  }))


  function initProductPage() {

    const productBlockFormEl = document.querySelector(".product-block--form");
    const productBlockFormElMutationObserver = new MutationObserver((mutationList, observer) => {
      if (mutationList[0]?.addedNodes[0]?.id) {
        const productTitleContainer = document.querySelector(".product-block--title");

        const wishlistHeroProductAddContainer = document.getElementById("wishlisthero-product-page-button-container");

        productTitleContainer.appendChild(wishlistHeroProductAddContainer);

        observer.disconnect();
      }
    })

    productBlockFormElMutationObserver.observe(productBlockFormEl, {
      childList: true, subtree: true
    })

    const productReviewsMutationObserver = new MutationObserver((mutations, observer) => {
      if (!productReviewsHeaderClickHandler) {
        const productReviewsContentEl = mutations[0].target.parentElement;
        productReviewsHeaderClickHandler = (e) => {

          // Only toggle visibility if we're clicking the header part...
          if (document.querySelector(".spr-header").contains(e.target)) {
            // In case we clicked the "write a review" button...
            if (e.target.className === "spr-summary-actions" || document.querySelector(".spr-summary-actions").contains(e.target)) {
              // Only keep or force open.
              productReviewsContentEl.toggleAttribute("data-closed", false);
            } else {
              // Toggle as normal.
              productReviewsContentEl.toggleAttribute("data-closed");
            }
          }
        }

        mutations[0].target.addEventListener("click", productReviewsHeaderClickHandler);
        observer.disconnect();
      }
    })
    const productReviewsContainerEl = document.getElementById("shopify-product-reviews");
    if (productReviewsContainerEl) {
      productReviewsContainerEl.parentElement.toggleAttribute("data-closed", true);
      productReviewsMutationObserver.observe(productReviewsContainerEl, {
        childList: true, subtree: true
      })

    }
  }

  const url = new URL(window.location.href);
  if (url.pathname.split("/").at(-2) === "products") {

    initProductPage();
  }

}
document.addEventListener("DOMContentLoaded", init)